import behorigRadgivare from './collections/behorig-radgivare';
import gt360 from './collections/gt360';
import foretagspresentationTest from './collections/foretagspresentation-test';
import services from './collections/services';
import { TreeCollection } from './types';

const collections: Record<string, TreeCollection> = {
  [gt360.id]: gt360,
  services,
  [behorigRadgivare.id]: behorigRadgivare,
  [foretagspresentationTest.id]: foretagspresentationTest,
};

export function getCollection(id: string): TreeCollection | undefined {
  return collections[id];
}

export function listCollections(): TreeCollection[] {
  return Object.values(collections);
}

export function registerCollection(collection: TreeCollection): void {
  collections[collection.id] = collection;
}
